
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/en-gb/products/identity-verification",
      function () {
        return require("private-next-pages/en-gb/products/identity-verification.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/en-gb/products/identity-verification"])
      });
    }
  